/// <amd-module name="Analytics/PipelineAnalytics/PipelineAnalyticsClient/RestClient/PipelineAnalytics" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\pipelines\vss-pipelineanalytics-web\analytics\pipelinereports\pipelineanalyticsclient\pipelineanalytics.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as PipelineAnalytics from "Analytics/PipelineAnalytics/PipelineAnalyticsClient/Contracts/PipelineAnalytics";

export interface IPipelineAnalyticsRestClient extends IVssRestClient {
    /**
     * @param project - Project ID or project name
     * @param pipelineDefinitionId - 
     * @param top - 
     * @param days - 
     * @param percentile - 
     * @param stageNames - 
     */
    getLeadTime(project: string, pipelineDefinitionId: number, top?: number, days?: number, percentile?: number, stageNames?: string[]): Promise<PipelineAnalytics.StageLeadTime[]>;
}

class PipelineAnalyticsRestClient extends RestClientBase implements IPipelineAnalyticsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param project - Project ID or project name
     * @param pipelineDefinitionId - 
     * @param top - 
     * @param days - 
     * @param percentile - 
     * @param stageNames - 
     */
    public async getLeadTime(
        project: string,
        pipelineDefinitionId: number,
        top?: number,
        days?: number,
        percentile?: number,
        stageNames?: string[]
        ): Promise<PipelineAnalytics.StageLeadTime[]> {

        const queryValues: any = {
            top: top,
            days: days,
            percentile: percentile,
            stageNames: stageNames && stageNames.join(",")
        };

        return this.beginRequest<PipelineAnalytics.StageLeadTime[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/pipelineAnalytics/LeadTime/pipelineDefinition/{pipelineDefinitionId}",
            routeValues: {
                project: project,
                pipelineDefinitionId: pipelineDefinitionId
            },
            queryParams: queryValues
        });
    }

}

export const PipelineAnalyticsClientName = "IPipelineAnalyticsRestClient";

export function getPipelineAnalyticsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPipelineAnalyticsRestClient {
    return pageContext.getRestClient<IPipelineAnalyticsRestClient>(PipelineAnalyticsClientName, options);
}

RestClients.add(PipelineAnalyticsClientName, { 
    factory: PipelineAnalyticsRestClient,
    options: {
        resourceAreaId: "059a1dcd-6243-4c85-b29c-0b833053c224",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
